<template>
  <div id="container">
    <pay-success class="notfind" title="" text=""/>
    <div class="btn">
      <el-button class="button" type="primary" :disabled="isdisabled"  @click="PayBack()">{{waitText}}</el-button>
    </div>
  </div>
</template>
<script>
import FZF from "@/components/404.vue";
import PaySuccess from "@/components/paysuccess.vue";
export default {
  name: 'index',
  components: { FZF, PaySuccess },
  data() {
    return {
      isId: '',
      isText: "",
      isdisabled:true,
      seconds: 10,
      waitText:"Please wait, verifying..."
      //?type=paysuccess
      //?type=payerror
      //?type=chpsuccess
      //?type=chperror
      //?type=waresuccess
      //?type=wareerror
      //?type=paypal
      //window.webkit.messageHandlers.(name).postMessage(键值对)
    }
  },
  mounted() {
    window.PayBack = this.PayBack;
    this.countdown()
  },
  created() {
    //console.log(this.$route.params.id,'this.$route')
    this.isId=this.$route.params.id
    if (this.$route.query.type.indexOf('order') != -1) {
      this.isText = "order"
    } else if (this.$route.query.type.indexOf('chp') != -1) {
      this.isText = 'chp'
    } else if (this.$route.query.type.indexOf('ware') != -1) {
      this.isText = 'ware'
    }
  },
  methods: {
    countdown() {
      let that = this
      that.isdisabled=true
    if (that.seconds > 0) {
        that.waitText=`Please wait, verifying... (${that.seconds}s)`
        that.seconds--;
        setTimeout(function(){
          that.countdown()
        }, 1000); // 1秒后递归调用
    } else {
      that.isdisabled=false
      that.waitText=`Not redirected? Click here.`
      that.PayBack()
    }
    } ,
    PayBack() {
      let that = this
      let ua = navigator.userAgent.toLowerCase();
      console.log('ua',ua)
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1|| ua.indexOf('android') > -1|| ua.indexOf('adr') > -1;
      console.log('isAndroid',isAndroid)
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      let data = { "id": this.isId, "type": this.isText }
      if (isiOS) {
        //ios
        console.log(" 我是ios",isiOS)
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.webkit.messageHandlers.PayPalCallback.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if(isAndroid){
        //android
        console.log("我是android",JSON.stringify(data));
        //这里是和安卓商量好的写法，调用安卓的finishActivity方法
        //android.PayCallback('我是android测试传值');           
        android.PayPalCallback(JSON.stringify(data));           
      }else{
        console.log("我是其他")
      }
    }
  }
}

</script>
<style scoped>
.btn {
  width: 90%;
  margin: 0 auto;text-align: center;
}
.notfind{
  margin-top: 30vh;
}
.btn a,
.btn .button {
  width: 60%;
  
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/apppaypal.vue